import { render, staticRenderFns } from "./BankHolidays.vue?vue&type=template&id=0abaf3be&"
import script from "./BankHolidays.vue?vue&type=script&lang=js&"
export * from "./BankHolidays.vue?vue&type=script&lang=js&"
import style0 from "./BankHolidays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports